// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1Vv8Q","hidden":"_3r-qG","loader":"rrb5B","rotate":"_2vrzy","active":"_3Mnzq","clip":"_3TyyJ","clip-reverse":"_1xlcT","clipReverse":"_1xlcT"};